import React, { useCallback, useEffect, useState } from "react";
// helper
import { useLocation, useNavigate } from "react-router";
import { PubSub } from "../../helper/pubSub";
import { useAccordion } from "../../contexts/AccordionContext";
// icons
import ClinicianLogo from "../../img/user/clinician.png";
import PatientLogo from "../../img/user/patient.png";
import { IoMdInformationCircle } from "react-icons/io";
import BasicSidebar from "./BasicSidebar";

interface SidebarAdminState {
  information: boolean;
}

const SidebarAdmin = () => {
  const { state: appState, handleAccordion, closeAll } = useAccordion();

  const location = useLocation();
  const navigate = useNavigate();

  const informationPaths = [
    "/admin/information",
    "/impressum",
    "/privacypolicy",
    "/contact",
  ]; //all paths belonging to information section. For these paths the menu stays open

  const [display, setDisplay] = useState<SidebarAdminState>({
    information: informationPaths.includes(location.pathname),
  });

  //get the accordion state from context
  const isPatientOpen = appState.admin.patients !== "-1";
  const isEmployeeOpen = appState.admin.employees !== "-1";

  const closeAllAccordions = useCallback(() => {
    console.log("Called closeAllAccordions");
    setDisplay({ information: false });
    closeAll("admin");
  }, [closeAll]);

  /**
   * State Handlers
   * Navigates to admin page if not already there
   * toggles the accordion with handleAccordion
   * Closes the information state
   */
  const handlePatients = () => {
    //navigate to admin page
    if (location.pathname !== "/admin") {
      navigate("/admin");
      setTimeout(() => {
        handleAccordion({ input: "patients", userType: "admin" });
      }, 100);
    } else {
      handleAccordion({ input: "patients", userType: "admin" });
    }
    setDisplay({ information: false });
  };

  const handleEmployees = () => {
    if (location.pathname !== "/admin") {
      navigate("/admin");
      setTimeout(() => {
        handleAccordion({ input: "employees", userType: "admin" });
      }, 100);
    } else {
      handleAccordion({ input: "employees", userType: "admin" });
    }
    setDisplay({ information: false });
  };

  const handleInformation = () => {
    closeAll("admin");
    navigate("/admin/information");
  };

  // listen to event to close all sidebars
  useEffect(() => {
    const subscription = PubSub.getInstance().subscribeToTopic(
      "close-sidebar-submenus",
      closeAllAccordions,
    );

    return () => {
      // clear subscription
      PubSub.getInstance().unsubscribe(subscription);
    };
  }, [closeAllAccordions]);

  const patientSidebarItem = {
    title: "Patient*innen",
    activeButton: isPatientOpen,
    onClickFunction: handlePatients,
    imgSrc: PatientLogo,
  };

  const employeeSidebarItem = {
    title: "Mitarbeitende",
    activeButton: isEmployeeOpen,
    onClickFunction: handleEmployees,
    imgSrc: ClinicianLogo,
  };

  const informationSidebarItem = {
    title: "Informationen",
    activeButton: display.information,
    onClickFunction: handleInformation,
    imgSrc: <IoMdInformationCircle size={25} />,
    buttonId: "clinic-stuff-sidebar-information",
    hiddenOnMobile: true,
  };

  return (
    <>
      <BasicSidebar
        sidebarItems={[
          patientSidebarItem,
          employeeSidebarItem,
          "---",
          informationSidebarItem,
        ]}
      />
    </>
  );
};
export default SidebarAdmin;
